// eslint-disable-next-line import/prefer-default-export
export const UNCOLORED_PSEUDO_COLOR_BY = "@unset";
